module.exports = __webpack_public_path__ + "img/amx-17.7e3f2276.webp";